import { lazy, Suspense, useEffect, useMemo, useState } from 'react';
import Header from '../components/landing/Header';
import Hero from '../components/landing/Hero';
import Features from '../components/landing/Features';
import Trailer from '../components/landing/Trailer';
import Platforms from '../components/landing/Platforms';
import FAQAccordion from '../components/landing/FAQAccordion';
import FinalCTA from '../components/landing/FinalCTA';
import Footer from '../components/landing/Footer';
import { landingContent } from '../content/gameLanding';
import '../styles/landing.css';

const Gallery = lazy(() => import('../components/landing/Gallery'));
const Reviews = lazy(() => import('../components/landing/Reviews'));

function LandingPage() {
  const [activeSection, setActiveSection] = useState('hero');

  const sectionIds = useMemo(
    () => landingContent.navigation.map((item) => item.id),
    []
  );

  useEffect(() => {
    const sections = sectionIds
      .map((id) => document.getElementById(id))
      .filter(Boolean);

    if (!sections.length) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const visibleEntries = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio);

        if (visibleEntries[0]?.target?.id) {
          setActiveSection(visibleEntries[0].target.id);
        }
      },
      {
        rootMargin: '-35% 0px -55% 0px',
        threshold: [0.1, 0.35, 0.6]
      }
    );

    sections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, [sectionIds]);

  const handlePrimaryAction = () => {
    const mainStoreUrl = landingContent.game.storeLinks?.[0]?.url;

    if (!mainStoreUrl) {
      alert('Store link coming soon');
      return;
    }

    window.open(mainStoreUrl, '_blank', 'noopener,noreferrer');
  };

  const handleTrailerAction = () => {
    document.getElementById('trailer')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="landing-page">
      <Header
        brand={landingContent.game.name}
        navigation={landingContent.navigation}
        activeSection={activeSection}
      />

      <main>
        <Hero
          game={landingContent.game}
          onPrimaryClick={handlePrimaryAction}
          onTrailerClick={handleTrailerAction}
        />

        <div className="container">

          <Trailer trailer={landingContent.trailer} />

          <Suspense fallback={<div className="loading">Loading gallery placeholders...</div>}>
            <Gallery screenshots={landingContent.screenshots} />
          </Suspense>

          <Suspense fallback={<div className="loading">Loading reviews placeholders...</div>}>
            <Reviews reviews={landingContent.reviews} />
          </Suspense>

  
        </div>
      </main>
    </div>
  );
}

export default LandingPage;
